import React, { useState } from 'react';
import axios from 'cccisd-axios';
import Table from 'cccisd-table';
import IconUp from 'cccisd-icons/thumbs-up2';
import IconUpFill from 'cccisd-icons/thumbs-up3';
import IconDown from 'cccisd-icons/thumbs-down2';
import IconDownFill from 'cccisd-icons/thumbs-down3';
import ArrowUp from 'cccisd-icons/arrow-up7';
import ArrowDown from 'cccisd-icons/arrow-down7';
import ArrowSide from 'cccisd-icons/arrow-resize3';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const SearchTest = () => {
    const [resources, setResources] = useState([]);
    const [searchIdA, setSearchIdA] = useState(0);
    const [searchIdB, setSearchIdB] = useState(0);
    const [thumbsA, setThumbsA] = useState([]);
    const [thumbsB, setThumbsB] = useState([]);

    const getResources = async query => {
        if (query.length === 0) {
            return;
        }
        let responseA = await axios.get(Boilerplate.route('api.resources.resource.semantic_search'), {
            params: {
                query,
                tagId: 'A-328',
            },
        });
        if (!responseA.data.data) {
            alert('Semantic search unavailable [A test]');
            return;
        }

        let responseB = await axios.get(Boilerplate.route('api.resources.resource.semantic_search'), {
            params: {
                query,
                tagId: 'B-328',
            },
        });
        if (!responseB.data.data) {
            alert('Semantic search unavailable [B test]');
            return;
        }
        setSearchIdA(responseA.data.data.searchId);
        setThumbsA([]);
        setSearchIdB(responseB.data.data.searchId);
        setThumbsB([]);

        let dataA = responseA.data.data.results;
        let dataB = responseB.data.data.results;

        const map = new Map();
        const aRankMap = new Map();
        let rank = 0;
        dataA.forEach(item => {
            let t = parseText(item.text);
            rank += 1;
            map.set(rank, {
                rank,
                id: item.id,
                scoreA: item.score,
                textA: t,
                scoreB: 0,
                textB: '',
                diff: 0,
            });
            aRankMap.set(item.id, rank);
        });
        rank = 0;
        dataB.forEach(item => {
            let t = parseText(item.text);
            rank += 1;
            if (map.has(rank)) {
                let itemA = map.get(rank);
                let aRank = aRankMap.get(item.id);
                map.set(rank, {
                    rank,
                    id: item.id,
                    scoreA: itemA.scoreA,
                    scoreB: item.score,
                    textA: itemA.textA,
                    textB: t,
                    diff: aRank ? aRank - rank : 'New',
                });
            } else {
                map.set(rank, {
                    rank,
                    id: item.id,
                    scoreA: 0,
                    scoreB: item.score,
                    textA: '',
                    textB: t,
                    diff: 0,
                });
            }
        });
        setResources(Array.from(map.values()));
    };

    const parseText = text => {
        const parts = text.split('\\');
        return {
            description: parts[0],
            tags: parts[1],
            terms: parts[2],
            title: parts[3],
            text: parts[4].slice(0, 80) + '...',
        };
    };

    const giveFeedback = async (resourceId, AB, direction) => {
        if (AB == 'A') {
            await axios.post(Boilerplate.route('api.resources.resource.semantic_feedback'), {
                resource_id: resourceId,
                search_id: searchIdA,
                direction,
            });
            setThumbs({ ...thumbsA, ['r' + resourceId]: direction });
        }
        if (AB == 'B') {
            await axios.post(Boilerplate.route('api.resources.resource.semantic_feedback'), {
                resource_id: resourceId,
                search_id: searchIdB,
                direction,
            });
            setThumbs({ ...thumbsB, ['r' + resourceId]: direction });
        }
    };

    return (
        <form
            className="queryForm"
            onSubmit={event => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const query = formData.get('query');
                getResources(query);
            }}
        >
            <div style={{ margin: '40px' }}>
                Resource query: <input type="text" size="80" name="query" style={{ margin: '10px' }} />
                <button type="submit" className="btn btl-lg btn-primary">
                    Search
                </button>
                {resources.length > 0 && (
                    <Table
                        columns={[
                            {
                                name: 'rank',
                                label: 'Rank',
                            },
                            {
                                name: 'scoreA',
                                label: 'Score',
                                render: (value, row) => {
                                    return <div>{+value.toFixed(1)}</div>;
                                },
                            },
                            /*
                            {
                                name: 'feedbackA',
                                label: 'Feedback?',
                                render: (value, row) => {
                                    let upIcon = '';
                                    if (thumbsA['r' + row.id] === 1) {
                                        upIcon = (
                                            <span onClick={() => giveFeedback(row.id, "A", 0)}>
                                                <IconUpFill />
                                            </span>
                                        );
                                    } else {
                                        upIcon = (
                                            <span onClick={() => giveFeedback(row.id, "A", 1)}>
                                                <IconUp />
                                            </span>
                                        );
                                    }

                                    let downIcon = '';
                                    if (thumbsA['r' + row.id] === -1) {
                                        downIcon = (
                                            <span onClick={() => giveFeedback(row.id, "A", 0)}>
                                                <IconDownFill />
                                            </span>
                                        );
                                    } else {
                                        downIcon = (
                                            <span onClick={() => giveFeedback(row.id, "A", -1)}>
                                                <IconDown />
                                            </span>
                                        );
                                    }
                                    return (
                                        <div>
                                            {upIcon}&nbsp;&nbsp;{downIcon}
                                        </div>
                                    );
                                },
                            },
*/
                            {
                                name: 'textA',
                                label: 'Description/Tags/Search Terms/Title/Text',
                                render: (value, row) => {
                                    return (
                                        <div>
                                            {value.description && <div>{value.description}</div>}
                                            {value.tags}
                                            <br />
                                            <i>
                                                <u>{value.terms}</u>
                                            </i>
                                            <br />
                                            <b>{value.title}</b>
                                            <br />
                                            {value.text}
                                            <br />
                                            {row.diff > 0 && (
                                                <div>
                                                    <ArrowUp /> {row.diff}
                                                </div>
                                            )}
                                            {row.diff < 0 && (
                                                <div>
                                                    <ArrowDown /> {-row.diff}
                                                </div>
                                            )}
                                            {row.diff === 0 && <ArrowSide />}
                                        </div>
                                    );
                                },
                            },
                            {
                                name: 'scoreB',
                                label: 'Score',
                                render: (value, row) => {
                                    return <div>{+value.toFixed(1)}</div>;
                                },
                            },
                            /*
                            {
                                name: 'feedbackB',
                                label: 'Feedback?',
                                render: (value, row) => {
                                    let upIcon = '';
                                    if (thumbsB['r' + row.id] === 1) {
                                        upIcon = (
                                            <span onClick={() => giveFeedback(row.id, "B", 0)}>
                                                <IconUpFill />
                                            </span>
                                        );
                                    } else {
                                        upIcon = (
                                            <span onClick={() => giveFeedback(row.id, "B", 1)}>
                                                <IconUp />
                                            </span>
                                        );
                                    }

                                    let downIcon = '';
                                    if (thumbsB['r' + row.id] === -1) {
                                        downIcon = (
                                            <span onClick={() => giveFeedback(row.id, "B", 0)}>
                                                <IconDownFill />
                                            </span>
                                        );
                                    } else {
                                        downIcon = (
                                            <span onClick={() => giveFeedback(row.id, "B", -1)}>
                                                <IconDown />
                                            </span>
                                        );
                                    }
                                    return (
                                        <div>
                                            {upIcon}&nbsp;&nbsp;{downIcon}
                                        </div>
                                    );
                                },
                            },
*/
                            {
                                name: 'textB',
                                label: 'Description/Tags/Title/Text',
                                render: (value, row) => {
                                    return (
                                        <div>
                                            {value.description && <div>{value.description}</div>}
                                            {value.tags}
                                            <br />
                                            <b>{value.title}</b>
                                            <br />
                                            {value.text}
                                            <br />
                                        </div>
                                    );
                                },
                            },
                        ]}
                        data={resources}
                        className="table"
                        showPerPageOptions={false}
                        hideShowingRowsSummary
                    />
                )}
            </div>
        </form>
    );
};

export default SearchTest;
